import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router-dom';
import { Routes } from '../../constants/routes';
import React from 'react';
import { useAppSelector } from '../../store/reducers';
const PrivateRoutesWithRedirect = () => {
    const { activeWallet: { isConnected } } = useAppSelector((state) => state.wallet);
    return isConnected ? _jsx(Outlet, {}) : _jsx(Navigate, { to: Routes.LOGIN });
};
export default PrivateRoutesWithRedirect;
